<template>
  <BaseView class="index-container">
    <div slot="contantView" class="content">
      <div class="index-panel">
        <div class="nav-panel">
          <HeaderView :active-index="5"/>
          <img src="../assets/spsc/hse/navBg.png" class="navImg"/>
        </div>
        <section class="nav-section">
          <div class="nav-info">
            <div class="nav-main-text" @click="goGoalPage('/')">Home</div>
            <div class="nav-arrow">></div>
            <div class="nav-sub-text" @click="goGoalPage('/hse')">HSE</div>
          </div>
          <div class="nav-line"></div>
        </section>
        <section class="content-panel">
          <div class="hse-panel">
            <div class="left-info">
              <div class="hse-pic"></div>
            </div>
            <div class="right-info">
              <div class="team-group">
                <div class="title-text">Sustainability</div>
                <div class="content-group">
                  <span>Sustainable development is at the heart of our purpose: Inventing green steel</span>
                  <span>product for a better world.</span>
                </div>
              </div>
              <div class="network-group">
                <div class="title-text">Human Rights</div>
                <div class="content-group">   
                  <span>We want to ensure that human rights standards are incorporated in all of our</span>
                  <span>operations, and that relevant employees receive up to date training on human</span>
                  <span>rights, in line with our human rights policy, Community Relations Procedure and</span>
                  <span>other international commitments.Human rights are integral to our approach to</span>
                  <span>sustainable development , and governs how we behave towards our employees, </span>
                  <span>contractors, suppliers, and the communities in which we work.</span>
                </div>  
              </div>
            </div>
          </div>
          <div class="system-group">
            <div class="title-text">Healthy And Safety</div>
            <div class="content-group">  
              <span>Safe, healthy, quality working lives for our people: Our workforce is safe and healthy, committed to our success and operates with integrity. Diversity is valued, and every</span>
              <span>individual is respected, and their potential is developed. Improving safety, and specifically preventing fatalities, is a key focus for everyone at SPSC. In fact, safety is, and</span>
              <span>always will be, our highest priority, and thus a condition of employment at SPSC. With more than 50 suppliers to succeed in our aim of having zero injuries, we have built a</span>
              <span>safety focused culture at our suppliers in China.</span>
            </div>
          </div>
          <div class="environment-group">
            <div class="title-text">Environment</div>
            <div class="content-group"> 
              <span>We know that air, water and land quality are among the most important issues for the communities around our operations. For the steel products fabrication, the main air </span>
              <span>emissions are dust and contamination of paint. All SPSC suppliers follow local laws and regulations, all steel and fabricated suppliers have follow the ISO14001</span>
              <span>requirement, all major structural steel elements are permanently marked during manufacture for potential reuse opportunities. and some suppliers accredited as below:</span>
            </div>
            <div class="environment-text">---ASI Environmental sustainability charter</div>
            <div class="environment-text">---Green building award</div>
          </div>
        </section>
        <FooterView />
      </div>
    </div>
  </BaseView>
</template>

<script>
import BaseView from '@/components/BaseView.vue'
import HeaderView from '@/components/HeaderView.vue'
import FooterView from '@/components/FooterView.vue'

export default {
  name: '',
  props: {

  },
  components: {
    BaseView,
    HeaderView,
    FooterView
  },
  data () {
    return {

    }
  },
  methods: {
    goGoalPage( pathName) {
      this.$router.replace({ path: pathName})
    }
  },
  created () {
  }
}
</script>
<style scoped lang="scss">

.index-container {
  background: #FFFFFF;
  width: 100%;
}
.index-panel {
  width: 100%;
  min-width: 1200px;
} 

.nav-panel {
  width: 100%;
  height: 100%;
}

.navImg {
  width: 100%;
  height: auto;
  margin-top: -80px;
}

.nav-section {
  width: 1200px;
  margin: 40px auto 60px auto;
}

.nav-info {
  display: flex;
  justify-content: flex-start;
  justify-items: center;
}

.nav-main-text, .nav-sub-text {
  font-size: 14px;
  color: #333333;
  cursor: pointer;
}

.nav-arrow {
  margin: 0 10px;
}

.nav-line {
  width: 100%;
  height: 1px;
  background: #D8D8D8;
  margin-top: 16px;
}

.content-panel {
  width: 1200px;
  margin: 0 auto 100px auto;

}

.hse-panel {
  width: 100%;
  display: flex;
}

.left-info {
  width: 456px;
}

.hse-pic {
  width: 456px;
  height: 432px;
  background: url('../assets/spsc/hse/hse.png') no-repeat;
  background-size: contain;
  margin-bottom: 98px;
}

.right-info {
  width: 580px;
  margin-left: 164px;
}

.team-group {
  margin: 10px 0 80px 0;
}

.network-group {
  margin: 0;
}

.title-text {
  font-size: 24px;
  font-weight: bold;
  color: #111111;
  margin-bottom: 20px;
}

.content-group {
  font-size: 16px;
  color: #333333;
  line-height: 28px;
}

span {
  white-space: nowrap;
}

.environment-group {
  margin-top: 80px;
}

.environment-text {
  margin-top: 20px;
}
</style>